module.exports = __webpack_public_path__ + "static/media/profitkit.3ac85969.md";